import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import { useCms } from '../contexts/CmsContext';
import { Link } from 'react-router-dom';
import { FaMapMarkerAlt, FaEnvelope, FaPhone } from 'react-icons/fa';
import './Footer.css';

const Footer = () => {
  const { language } = useLanguage();
  const { getContent } = useCms();
  const t = getContent(language);

  const handleNavClick = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-column">
            <div className="footer-logo"></div>
            <p className="footer-description">
              {t.footer.description}
            </p>
          </div>
          <div className="footer-column">
            <h4 className="footer-heading">{t.footer.navigation}</h4>
            <ul className="footer-links">
              <li><Link to="/" onClick={handleNavClick}>{t.nav.home}</Link></li>
              <li><Link to="/about" onClick={handleNavClick}>{t.nav.about}</Link></li>
              <li><Link to="/service" onClick={handleNavClick}>{t.nav.service}</Link></li>
              <li><Link to="/career" onClick={handleNavClick}>{t.nav.career}</Link></li>
              <li><Link to="/contact" onClick={handleNavClick}>{t.nav.contact}</Link></li>
            </ul>
          </div>
          <div className="footer-column">
            <h4 className="footer-heading">{t.footer.contact}</h4>
            <div className="contact-info">
              <div className="contact-item">
                <span className="contact-icon"><FaMapMarkerAlt /></span>
                <span>{t.footer.contactInfo.location}</span>
              </div>
              <div className="contact-item">
                <span className="contact-icon"><FaEnvelope /></span>
                <span>{t.footer.contactInfo.email}</span>
              </div>
              <div className="contact-item">
                <span className="contact-icon"><FaPhone /></span>
                <span>{t.footer.contactInfo.phone}</span>
              </div>
            </div>
          </div>
        </div>
        <div className="footer-bottom">
          <div className="footer-copyright">
            {t.footer.copyright}
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
